module.exports = __webpack_public_path__ + "img/mv05.51be49bc.png";